<template>
  <v-menu :position-x="position.x" :position-y="position.y" v-model="menu" :close-on-content-click="false" :nudge-width="300" offset-x>
    <v-form ref="form" style="width: 100%;">
      <v-card>
        <v-card-title class="title py-1">
          {{ type }} guideline
          <v-spacer />
          <v-btn class="ma-0" icon @click="close()">
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider />
        <v-card-text>
          <v-select v-model="formObject.guidelineId" :rules="[rules.required]" :error-messages="errorMessages.guidelineStations" label="Guideline" item-value="Id" item-text="GuidelineName" :items="unusedGuidelines">
            <template v-slot:item="{ item }">
              <div>
                <v-list-tile-title>
                  {{ item.GuidelineName }}
                </v-list-tile-title>
                <v-list-tile-sub-title>
                  {{ item.GuidelineLongName }}
                </v-list-tile-sub-title>
              </div>
            </template>
          </v-select>
        </v-card-text>
        <v-card-actions>
          <v-spacer />

          <v-btn color="success" outline @click="submit()">{{$t('Button.Save')}}</v-btn>
          <v-btn outline color="secondary" @click="close()">{{$t('Button.Cancel')}}</v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-menu>
</template>

<script>
  const TYPES = {
    create: 'Add',
    update: 'Edit',
  }

  const guidelineStationExists = 'Guideline already used'

  export default {
    props: {
      configuration: Object,
      position: {
        type: Object,
        default: () => ({
          x: 0,
          y: 0,
        }),
      },
    },
    data: () => ({
      menu: false,
      formObject: {},
      initialObject: {
        guidelineId: null,
        stationIds: [],
      },
      errorMessages: {
        guidelineStations: [],
      },
      type: TYPES.create,
      initialItem: null,
    }),
    computed: {
      rules() {
        return {
          required: (v) => !!v || 'Required',
        }
      },
      unusedGuidelines() {
        return this.guidelines.filter(g => !this.usedGuidelinesIndex[g.Id] || g.Id == this.formObject.guidelineId)
      },
      guidelines() {
        return this.$store.getters['guidelines/guidelineOfCurrentTenant']
      },
      usedGuidelinesIndex() {
        let index = {}
        this.configuration.guidelineStations.forEach(gs => index[gs.guidelineId] = gs)
        return index
      },
    },
    methods: {
      guidelineStationIndex(v) {
        return this.configuration.guidelineStations.findIndex(gs => gs.guidelineId == v)
      },
      submit() {
        if (!this.$refs.form.validate()) return

        if (this.type == TYPES.create) {
          this.create()
        } else if (this.type == TYPES.update) {
          this.update()
        } else {
          throw 'Unsupported type'
        }
      },
      update() {
        let guidelineStation = JSON.parse(JSON.stringify(this.formObject))
        let index = this.configuration.guidelineStations.findIndex(gs => gs.guidelineId == this.initialItem.guidelineId)
        let guidelineStationsIndex = this.guidelineStationIndex(this.initialItem.guidelineId)

        if (index != -1 && guidelineStationsIndex != index) {
          this.errorMessages.guidelineStations = [guidelineStationExists]
          return
        }

        this.errorMessages.guidelineStations = []
        this.configuration.guidelineStations.splice(index, 1, guidelineStation)

        this.close()
      },
      create() {
        let guidelineStation = JSON.parse(JSON.stringify(this.formObject))
        let index = this.guidelineStationIndex(guidelineStation.guidelineId)

        if (index != -1) {
          this.errorMessages.guidelineStations = [guidelineStationExists]
          return
        }

        this.errorMessages.guidelineStations = []
        this.configuration.guidelineStations.push(guidelineStation)

        this.close()
      },
      show(item) {
        this.type = TYPES.create
        this.menu = true

        this.initialItem = item
        if (item) {
          this.type = TYPES.update

          this.formObject = {
            ...this.formObject,
            ...item,
          }
        } else {
          this.reassign()
        }
      },
      close() {
        this.reassign()
        this.menu = false
      },
      reassign() {
        this.formObject = JSON.parse(JSON.stringify(this.initialObject))
        this.$refs.form.reset()
      },
    },
    mounted() {
      this.reassign()
    },
  }
</script>